import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-m-3" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "hier",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-sorting-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.member.caption), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('updateHierarchy')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.multiHierarchy.detail1')) + " ", 1),
        _createVNode("b", null, _toDisplayString(_ctx.member.hierarchies[_ctx.member.selectedHierarchyPosition].caption) + ".", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('documentExecution.olap.multiHierarchy.detail2')), 1)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_Dropdown, {
            id: "hier",
            class: "kn-material-input",
            modelValue: _ctx.selecetedMultiHierUN,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selecetedMultiHierUN = $event)),
            options: _ctx.member.hierarchies,
            optionLabel: "caption",
            optionValue: "uniqueName",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setMultiHierUN', _ctx.selecetedMultiHierUN)))
          }, null, 8, ["modelValue", "options"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('documentExecution.olap.multiHierarchy.dropdownLabel')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}